import React, { forwardRef, LegacyRef } from 'react';
import { SponsoredProductName } from './sponsored-product-name';
import {
  productNameTextInWidget,
  productNameWithoutReviews,
  sponsoredProductInfo,
  sponsoredInfoProductWrapper,
  marginStyle,
} from './styles';
import { cn } from 'utils/classnames';
import type { ProductCardProps } from 'common/components/product-card/types';
import {
  offerOldPriceWrapper,
  offerWrapper,
  productName,
  productNameText,
} from 'common/components/product-card/styles';
import { useProductCard } from 'common/components/product-card/hooks/use-product-card';
import { ProductImageLink } from 'common/components/product-card/product-image-link';
import { SponsoredProductPriceToDisplay } from './sponsored-product-price-to-display';
import { ProductActionButtons } from 'common/components/product-card/product-action-buttons';
import { cartButton, productBaseWrapperSimplified } from './common-styles';
import { SponsoredProductCartButton } from './sponsored-product-cart-button';

export const SponsoredProductCard = forwardRef<HTMLDivElement, ProductCardProps>(
  (
    {
      className,
      product,
      type,
      label,
      inBasket,
      isBasketLoading,
      qty,
      onClick,
      onCartAdd,
      onCartRemove,
      reviews,
      onQtyUpdate,
      inWidget,
      isSimplifiedVariant,
      isSponsored,
    },
    ref,
  ) => {
    const {
      handleAdd,
      handleRemove,
      handleUpdate,
      hasOldPrice,
      link,
      loyaltyRewardLabel,
      setShowMeasurementTip,
      showMeasurementTip,
    } = useProductCard({
      product,
      onCartAdd,
      onCartRemove,
      onQtyUpdate,
    });
    const isAnyReviews = reviews && reviews.reviews_number > 0;
    return (
      <div
        className={cn(productBaseWrapperSimplified, type, className)}
        data-qa-product=""
        ref={ref as LegacyRef<HTMLDivElement>}
      >
        <ProductImageLink
          link={link}
          product={product}
          onClick={onClick}
          type={type}
          label={label}
          inWidget={inWidget}
          loyaltyRewardLabel={loyaltyRewardLabel}
          isPageTop={true}
          isSimplifiedVariant={isSimplifiedVariant}
          isSponsored={isSponsored}
        />
        <div className={sponsoredInfoProductWrapper}>
          <div
            className={cn(
              offerWrapper,
              !isSimplifiedVariant ? marginStyle : '',
              hasOldPrice ? offerOldPriceWrapper : '',
            )}
          >
            <div className={sponsoredProductInfo}>
              <SponsoredProductPriceToDisplay
                hasOldPrice={hasOldPrice}
                price={product.price}
                productPriceCategory={label}
              />

              <SponsoredProductName
                data-qa="product-name"
                href={link}
                onClick={() => onClick('productNameLink')}
                className={productName}
                textClassName={cn(
                  inWidget ? productNameTextInWidget : productNameText,
                  !isAnyReviews && productNameWithoutReviews,
                )}
              >
                {product.displayedName}
              </SponsoredProductName>
            </div>
          </div>

          {!isSimplifiedVariant ? (
            <ProductActionButtons
              showMeasurementTip={showMeasurementTip}
              setShowMeasurementTip={setShowMeasurementTip}
              qty={qty}
              product={product}
              inBasket={inBasket}
              handleRemove={handleRemove}
              handleUpdate={handleUpdate}
            >
              <SponsoredProductCartButton
                className={cartButton}
                isLoading={isBasketLoading}
                size="s"
                onClick={handleAdd}
              />
            </ProductActionButtons>
          ) : null}
        </div>
      </div>
    );
  },
);
